import { render, staticRenderFns } from "./AccountStatementContent.vue?vue&type=template&id=0a371cd0&"
import script from "./AccountStatementContent.vue?vue&type=script&lang=js&"
export * from "./AccountStatementContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports